import { render, staticRenderFns } from "./BasketCategories.vue?vue&type=template&id=b1ed4768"
import script from "./BasketCategories.vue?vue&type=script&lang=js"
export * from "./BasketCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports